export function normalize(text: String | undefined) {
  if (text) {
    return text.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  }
  return '';
}
